import React, { useCallback, useState, useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import Modal from '@ublique/components/LoadingModal'
import Loading from '@ublique/components/Loading'
import 'pages/Administration/components/index.scss'

import {
  handleUserUpdate,
  isUsernameDuplicated
} from 'pages/Administration/Tabs/Users/helpers'
import { sendNotification } from 'pages/Administration/helpers'
import DefaultForm from '../DefaultForm'
import {
  createUser,
  updateUser
} from 'services/api/administration/rolesUsersService'
import { isEmpty } from 'lodash'
import { EMAIL_REGEX } from 'pages/Administration/constants'

const UserModal = ({ open, close, data }) => {
  const { modalType, userValue, roles, users, gridApi } = data
  const allRoles = roles

  const defaultUser = {
    username: '',
    name: '',
    email: '',
    roles: []
  }
  const { t } = useTranslation('Administration', 'Common')
  const [value, setValue] = useState(userValue || defaultUser)

  const [isUsernameDuplicate, setIsUsernameDuplicate] = useState(false)
  const [isEmailValid, setIsEmailValid] = useState(false)
  const [isNameInvalid, setIsNameInvalid] = useState(false)
  const [isAuthInvalid, setIsAuthInvalid] = useState(false)
  const [isFormInvalid, setIsFormInvalid] = useState(true)

  const [isLoading, setIsLoading] = useState(false)

  const onAddUserSubmit = async () => {
    if (modalType === 'AddUser') {
      const user = processDuplicateUsername(value)
      const email = processEmailValidation(value)
      const name = processNameValidation(value)
      // const auth = processAuthValidation(value)

      if (user || email || name) return
    }
    function getPayload() {
      const payload = {
        email: value.email === '' ? null : value.email,
        name: value.name.trim(),
        username: value.username.trim(),
        roles: value.roles.map((role) => role.value)
      }
      return payload
    }
    setIsLoading(true)
    const payload = getPayload()

    try {
      modalType === 'AddUser'
        ? await createUser(payload)
        : await updateUser(payload, value.id)

      sendNotification({
        t,
        info: modalType === 'AddUser' ? 'Add' : 'Update',
        kind: 'success'
      })

      gridApi?.deselectAll()
    } catch (err) {
      console.error(err)
      setIsLoading(false)
      close()
    }
    setIsLoading(false)
    close()
  }

  const processDuplicateUsername = ({ username }) => {
    if (username === '') {
      setIsUsernameDuplicate(true)
      return true
    } else if (!isEmpty(users) && username) {
      const val = isUsernameDuplicated(username, users)
      setIsUsernameDuplicate(val)
      return val
    }
  }

  const processNameValidation = ({ name }) => {
    name !== undefined && setIsNameInvalid(name === '')
    return name === ''
  }

  // const processAuthValidation = ({ roles }) => {
  //   roles && setIsAuthInvalid(roles.length === 0)
  //   return roles && roles.length === 0
  // }

  const processEmailValidation = ({ email }) => {
    if (email === '') {
      setIsEmailValid(true)
      return true
    } else if (!isEmpty(email) && email) {
      const re = EMAIL_REGEX
      setIsEmailValid(!re.test(email))
      return !re.test(email)
    }
  }

  const handleOnAddChange = useCallback(
    (value) => {
      setValue((prevState) => ({
        ...prevState,
        ...value
      }))
      processDuplicateUsername(value)
      processEmailValidation(value)
      processNameValidation(value)
      // processAuthValidation(value)
    },
    [value]
  )
  useEffect(() => {
    setIsFormInvalid(
      isEmailValid || isUsernameDuplicate || isNameInvalid || isAuthInvalid
    )
  }, [isEmailValid, isUsernameDuplicate, isNameInvalid, isAuthInvalid])

  return (
    <Modal
      open={open}
      id='selectedRowsLength'
      preventCloseOnClickOutside
      className='admin-view'
      modalHeading={t(`Administration:UsersManagement.${modalType}`)}
      primaryButtonText={t('Common:Save')}
      secondaryButtonText={t('Common:Cancel')}
      iconDescription={t('Common:Close')}
      primaryButtonDisabled={isFormInvalid}
      onRequestSubmit={onAddUserSubmit}
      onRequestClose={close}
      onSecondarySubmit={close}
    >
        {isLoading && <Loading />}
        <DefaultForm
          permissionType='users'
          formFields={handleUserUpdate(
            handleOnAddChange,
            value,
            allRoles,
            isUsernameDuplicate,
            isEmailValid,
            isNameInvalid,
            isAuthInvalid,
            modalType
          )}
          t={t}
        />
    </Modal>
  )
}

export default UserModal
